// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cairo:wght@900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css - Ensure responsiveness and fixed positioning */

.chat-header {
  /*position: fixed;*/
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 0.5px 20px #9c0058;
  padding: 10px;
  font-family: 'Cairo', sans-serif;
  font-weight: 900;
  z-index: 2;
  box-sizing: border-box;
}

.logo-and-text {
  display: flex;
  align-items: center;
}

.chat-logo {
  height: 50px; /* Adjusted for consistent sizing */
  width: auto; /* Maintain aspect ratio */
  margin-right: 15px;
}

.welcome, .H1 {
  color: #9c0058;
  margin: 0;
  padding: 0;
  font-size: 1rem; /* Adjust based on preference */
}

.contact-and-minimize {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-top: 20px;
}

.contact-us-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  border-radius: 15px;
  padding: 5px 10px;
  
}

.beta {
  color: #9c0058;
  margin-right: 10px; /* Adjusted spacing */
  margin-left: 10px;
  
  
}

.icon-phone {
  margin-right: 5px;
}

.phone-number, .phone-number-plus {
  color: #9c0058;
  text-decoration: none;
  margin: 0 5px; /* Adjusted spacing */
}

.minimize-button {
  background: none;
  border: none;
  color: #9c0058;
  font-size: 1.5rem;
  cursor: pointer;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .chat-header {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }


}

@media (max-width: 480px) {
  .chat-header {
    padding: 5px;
  }

  .chat-logo {
    height: 40px; /* Smaller logo on very small screens */
  }

  .minimize-button {
    font-size: 1.2rem; /* Smaller button on very small screens */
  }
}

.chat-assistant-logo {
    background-color: transparent; /* No background */
    border: none; /* No border */
    cursor: pointer; /* Change cursor on hover */
    padding: 0; /* No padding */
    position: fixed; /* Fixed position */
    bottom: 30px; /* Position from the bottom */
    right: 30px; /* Position from the left, changed from right to left */
    z-index: 1001; /* Above the chat window */
  }
  
  .chat-assistant-logo img {
    width: 100px; /* Smaller size for the logo */
    height: auto; /* Maintain aspect ratio */
  }
  .chat-window {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    background-color: white;
    overflow: hidden;
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }
  
  /* Keeping responsive adjustments for smaller devices */
  @media (max-width: 768px) {
    .chat-window {
      border-radius: 0; /* Full-window might not need border-radius */
    }
  }
  
  @media (max-width: 480px) {
    .chat-window {
      border-radius: 0; /* Adjusting for smaller devices */
    }
  }
  
  /* Scrollbar adjustments */
  .webchat-container::-webkit-scrollbar, 
  .messages-container::-webkit-scrollbar {
    display: none; /* Hides scrollbar for a cleaner look */
  }
  
  .webchat-container,
  .messages-container {
    -ms-overflow-style: none; /* For Internet Explorer and Edge */
    scrollbar-width: none; /* For Firefox */
  }
  .chat-messages {
    flex: 1 1;
    overflow-y: auto;
  }
  
  
  
  .webchat-container::-webkit-scrollbar, 
  .messages-container::-webkit-scrollbar {
    display: none;
  }
  
  .webchat-container,
  .messages-container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  
  .webchat-container {
    flex-grow: 1;
    overflow-y: auto;
  }
  
  #banner h1 {
    font-size: calc(10px + 1.5vmin); 
  }
  
  #banner-icon {
    width: 20%; 
    height: auto;
  }
  
  #webchat {
    height: calc(100vh - 130px); 
    top: 100px; 
  }
  
  @media (max-height: 600px) {
    #webchat {
      height: calc(100vh - 120px); 
      top: 80px;
    }
  }
  /* .webchat__send-box {
    position: sticky;
    bottom: 0;
  } */
  
  

  .corner {
      background-color: #9c0058;
      overflow: hidden;
      position: absolute;
      left: -3em;
      top: 0.5em;
      transform: rotate(-45deg);
  
  }
  .corner span {
      border: 1px solid #9c0058;
      color: #fff;
      display: block;
      font-size:.8em;
      font-weight:bold;
      padding: 0.5em 4em;
      text-align: center;
      text-decoration: none;
      text-shadow: 1px 1px 1px #000;
  }`, "",{"version":3,"sources":["webpack://./src/components/Styles/kahramaa.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAG7D;EACE,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,mCAAmC;EACjD,WAAW,EAAE,0BAA0B;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,cAAc;EACd,kBAAkB,EAAE,qBAAqB;EACzC,iBAAiB;;;AAGnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;;AAGF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY,EAAE,uCAAuC;EACvD;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;EAC9D;AACF;;AAEA;IACI,6BAA6B,EAAE,kBAAkB;IACjD,YAAY,EAAE,cAAc;IAC5B,eAAe,EAAE,2BAA2B;IAC5C,UAAU,EAAE,eAAe;IAC3B,eAAe,EAAE,mBAAmB;IACpC,YAAY,EAAE,6BAA6B;IAC3C,WAAW,EAAE,uDAAuD;IACpE,aAAa,EAAE,0BAA0B;EAC3C;;EAEA;IACE,YAAY,EAAE,8BAA8B;IAC5C,YAAY,EAAE,0BAA0B;EAC1C;EACA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY,EAAE,wBAAwB;IACtC,aAAa,EAAE,yBAAyB;IACxC,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA,uDAAuD;EACvD;IACE;MACE,gBAAgB,EAAE,6CAA6C;IACjE;EACF;;EAEA;IACE;MACE,gBAAgB,EAAE,kCAAkC;IACtD;EACF;;EAEA,0BAA0B;EAC1B;;IAEE,aAAa,EAAE,uCAAuC;EACxD;;EAEA;;IAEE,wBAAwB,EAAE,mCAAmC;IAC7D,qBAAqB,EAAE,gBAAgB;EACzC;EACA;IACE,SAAO;IACP,gBAAgB;EAClB;;;;EAIA;;IAEE,aAAa;EACf;;EAEA;;IAEE,wBAAwB;IACxB,qBAAqB;EACvB;;;EAGA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE;MACE,2BAA2B;MAC3B,SAAS;IACX;EACF;EACA;;;KAGG;;;;EAIH;MACI,yBAAyB;MACzB,gBAAgB;MAChB,kBAAkB;MAClB,UAAU;MACV,UAAU;MAGV,yBAAyB;;EAE7B;EACA;MACI,yBAAyB;MACzB,WAAW;MACX,cAAc;MACd,cAAc;MACd,gBAAgB;MAChB,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,6BAA6B;EACjC","sourcesContent":["/* Header.css - Ensure responsiveness and fixed positioning */\n@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@900&display=swap');\n\n.chat-header {\n  /*position: fixed;*/\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n  box-shadow: 0 0.5px 20px #9c0058;\n  padding: 10px;\n  font-family: 'Cairo', sans-serif;\n  font-weight: 900;\n  z-index: 2;\n  box-sizing: border-box;\n}\n\n.logo-and-text {\n  display: flex;\n  align-items: center;\n}\n\n.chat-logo {\n  height: 50px; /* Adjusted for consistent sizing */\n  width: auto; /* Maintain aspect ratio */\n  margin-right: 15px;\n}\n\n.welcome, .H1 {\n  color: #9c0058;\n  margin: 0;\n  padding: 0;\n  font-size: 1rem; /* Adjust based on preference */\n}\n\n.contact-and-minimize {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.contact-us-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f5f5;\n  border-radius: 15px;\n  padding: 5px 10px;\n  \n}\n\n.beta {\n  color: #9c0058;\n  margin-right: 10px; /* Adjusted spacing */\n  margin-left: 10px;\n  \n  \n}\n\n.icon-phone {\n  margin-right: 5px;\n}\n\n.phone-number, .phone-number-plus {\n  color: #9c0058;\n  text-decoration: none;\n  margin: 0 5px; /* Adjusted spacing */\n}\n\n.minimize-button {\n  background: none;\n  border: none;\n  color: #9c0058;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .chat-header {\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n  }\n\n\n}\n\n@media (max-width: 480px) {\n  .chat-header {\n    padding: 5px;\n  }\n\n  .chat-logo {\n    height: 40px; /* Smaller logo on very small screens */\n  }\n\n  .minimize-button {\n    font-size: 1.2rem; /* Smaller button on very small screens */\n  }\n}\n\n.chat-assistant-logo {\n    background-color: transparent; /* No background */\n    border: none; /* No border */\n    cursor: pointer; /* Change cursor on hover */\n    padding: 0; /* No padding */\n    position: fixed; /* Fixed position */\n    bottom: 30px; /* Position from the bottom */\n    right: 30px; /* Position from the left, changed from right to left */\n    z-index: 1001; /* Above the chat window */\n  }\n  \n  .chat-assistant-logo img {\n    width: 100px; /* Smaller size for the logo */\n    height: auto; /* Maintain aspect ratio */\n  }\n  .chat-window {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw; /* Full viewport width */\n    height: 100vh; /* Full viewport height */\n    background-color: white;\n    overflow: hidden;\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Keeping responsive adjustments for smaller devices */\n  @media (max-width: 768px) {\n    .chat-window {\n      border-radius: 0; /* Full-window might not need border-radius */\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .chat-window {\n      border-radius: 0; /* Adjusting for smaller devices */\n    }\n  }\n  \n  /* Scrollbar adjustments */\n  .webchat-container::-webkit-scrollbar, \n  .messages-container::-webkit-scrollbar {\n    display: none; /* Hides scrollbar for a cleaner look */\n  }\n  \n  .webchat-container,\n  .messages-container {\n    -ms-overflow-style: none; /* For Internet Explorer and Edge */\n    scrollbar-width: none; /* For Firefox */\n  }\n  .chat-messages {\n    flex: 1;\n    overflow-y: auto;\n  }\n  \n  \n  \n  .webchat-container::-webkit-scrollbar, \n  .messages-container::-webkit-scrollbar {\n    display: none;\n  }\n  \n  .webchat-container,\n  .messages-container {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  \n  \n  .webchat-container {\n    flex-grow: 1;\n    overflow-y: auto;\n  }\n  \n  #banner h1 {\n    font-size: calc(10px + 1.5vmin); \n  }\n  \n  #banner-icon {\n    width: 20%; \n    height: auto;\n  }\n  \n  #webchat {\n    height: calc(100vh - 130px); \n    top: 100px; \n  }\n  \n  @media (max-height: 600px) {\n    #webchat {\n      height: calc(100vh - 120px); \n      top: 80px;\n    }\n  }\n  /* .webchat__send-box {\n    position: sticky;\n    bottom: 0;\n  } */\n  \n  \n\n  .corner {\n      background-color: #9c0058;\n      overflow: hidden;\n      position: absolute;\n      left: -3em;\n      top: 0.5em;\n      -moz-transform: rotate(-45deg);\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n  \n  }\n  .corner span {\n      border: 1px solid #9c0058;\n      color: #fff;\n      display: block;\n      font-size:.8em;\n      font-weight:bold;\n      padding: 0.5em 4em;\n      text-align: center;\n      text-decoration: none;\n      text-shadow: 1px 1px 1px #000;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
